export default __webpack_public_path__ + "static/media/ValentineDaySetMenu.aaa59bd3.pdf";